import { Skeleton, VStack, HStack } from '@cdl/heartbeat-react';
import { LoadingBaseClusters } from './LoadingBaseClusters';

const SKELETON_BASE_CLUSTER_WIDTH = 450;
const SKELETON_BASE_CLUSTER_HEIGHT = 150;
const MORPHOLOGY_ROW_NUMBER = 2;
const MORPHOLOGY_NUMBER = 3;

export const LoadingMerging: React.FC = () => {
  return (
    <LoadingBaseClusters>
      <VStack alignItems='start' m='m'>
        <HStack>
          <Skeleton width={170} height='1rem' />
          <Skeleton width={170} height='2rem' variant='heartbeat' />
        </HStack>
        <VStack>
          {Array.from(Array(MORPHOLOGY_ROW_NUMBER), (_x, i) => i).map((i) => (
            <HStack key={i}>
              {Array.from(Array(MORPHOLOGY_NUMBER), (_x, i) => i).map((i) => (
                <Skeleton
                  key={i}
                  variant='heartbeat'
                  width={SKELETON_BASE_CLUSTER_WIDTH}
                  height={SKELETON_BASE_CLUSTER_HEIGHT}
                />
              ))}
            </HStack>
          ))}
        </VStack>
      </VStack>
    </LoadingBaseClusters>
  );
};
